// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1aH9J","notes":"Notes_notes__2e_p5","note":"Notes_note__2F3VA","markdown":"Notes_markdown__3PObR"};